import { WidgetProps } from "@rjsf/core";
import { isNil } from "lodash";

export const ReadOnlyValueWithNoDataWidget = (props: WidgetProps) =>
    isNil(props.value) ? <span>No Data</span> : <span dangerouslySetInnerHTML={{ __html: props.value }} />;
